import { createContext, useContext } from 'react';
import { API_PATH, DEFAULT_API_ORIGIN, type AppConfig } from './config';

// T-283 — how this build runs, readable from the tree.
//
// The shell's account switch has to know which account is on screen and whether this build can switch at all,
// and there is exactly one honest source for that: the `AppConfig` `main.tsx` read ONCE from the address it was
// given. **Nothing below this reads `window.location` again** — that is T-076-W7's defect, where the API client
// re-read the address and a test's synthetic location was silently ignored.
//
// The default is a plain demo build, so every existing test (and the kitchen sink) renders without a provider
// and gets what a demo build is: the committed demo, no switches, no live account.

export const DEMO_APP_CONFIG: AppConfig = {
  transport: 'demo',
  apiBuild: false,
  apiBaseUrl: DEFAULT_API_ORIGIN + API_PATH,
  demoNow: null,
  dataset: 'demo',
  liveAccountKey: null,
  qa: {},
  qaKey: '',
};

const AppConfigContext = createContext<AppConfig>(DEMO_APP_CONFIG);

export const AppConfigProvider = AppConfigContext.Provider;

export function useAppConfig(): AppConfig {
  return useContext(AppConfigContext);
}
